webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Destination__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_List__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SoundUpload__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Register__ = __webpack_require__(26);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: { Destination: __WEBPACK_IMPORTED_MODULE_0__components_Destination__["a" /* default */], List: __WEBPACK_IMPORTED_MODULE_1__components_List__["a" /* default */], SoundUpload: __WEBPACK_IMPORTED_MODULE_2__components_SoundUpload__["a" /* default */], Register: __WEBPACK_IMPORTED_MODULE_3__components_Register__["a" /* default */] },
  data: function data() {
    return {
      dest: 'test',
      soundToPlay: '',
      currentTab: '',
      reloadDest: 0,
      tabs: ['Register', 'Destination', 'SoundUpload']
    };
  },
  methods: {
    showDest: function showDest() {
      console.log(this.dest);
      console.log(this.soundToPlay);
    },
    selectedComponent: function selectedComponent(component, target) {
      if (component === target) {
        return '';
      }
      return 'hidden';
    }
  },
  watch: {
    currentTab: function currentTab() {
      if (this.currentTab === 'Destination') {
        this.reloadDest++;
      }
    }
  }
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Destination_vue__ = __webpack_require__(5);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3efdedad_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_jade_node_modules_vue_loader_lib_selector_type_template_index_0_Destination_vue__ = __webpack_require__(20);
function injectStyle (ssrContext) {
  __webpack_require__(19)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Destination_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3efdedad_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_jade_node_modules_vue_loader_lib_selector_type_template_index_0_Destination_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'destination',
  data: function data() {
    var basepath = '';
    if (false) {
      basepath = 'http://localhost:10101';
    };
    return {
      clients: [],
      client: '',
      clientsURL: basepath + '/api/v1/clients'
    };
  },

  props: ['destination', 'reloadDest'],
  watch: {
    client: function client() {
      this.updateDest(this.client);
    },
    reloadDest: function reloadDest() {
      this.updateClients();
    }
  },
  methods: {
    updateDest: function updateDest(destination) {
      this.$emit('update:destination', destination);
    },
    updateClients: function updateClients() {
      var _this = this;

      this.$http.get(this.clientsURL).then(function (response) {
        _this.clients = response.data.clients;
      });
    }
  },
  created: function created() {
    this.updateClients();
  }
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__(7);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ec9d304_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_jade_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__(22);
function injectStyle (ssrContext) {
  __webpack_require__(21)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ec9d304_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_jade_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bootstrap_toggle__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bootstrap_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_bootstrap_toggle__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'list',
  components: { BootstrapToggle: __WEBPACK_IMPORTED_MODULE_0_vue_bootstrap_toggle___default.a },
  props: {
    destination: String,
    // tag: Boolean,
    soundToPlay: String
  },
  data: function data() {
    var basepath = '';
    if (false) {
      basepath = 'http://localhost:10101';
    };
    return {
      tag: false,
      search: '',
      sounds: [],
      playOnServer: true,
      soundPath: '',
      playLocallyURL: basepath + '/api/v1/sounds/',
      playURL: basepath + '/api/v1/play/',
      soundsURL: basepath + '/api/v1/sounds'
    };
  },

  computed: {
    tagNames: function tagNames() {
      var _this = this;

      var t = [];
      // push all tags in 't'
      this.sounds.forEach(function (sound) {
        if (sound.tags) {
          sound.tags.forEach(function (tag) {
            t.push(tag);
          });
        }
      });
      // deduplicates tags in t
      var res = t.filter(function (value, index, self) {
        return self.indexOf(value) === index;
      }).filter(function (tag) {
        // filter out with filter
        return tag.toLowerCase().includes(_this.search.toLowerCase());
      });
      return res;
    },
    soundNames: function soundNames() {
      var _this2 = this;

      var list = [];
      // filter sounds and then put all sound.name in a list.
      this.sounds.filter(function (sound) {
        return sound.name.toLowerCase().includes(_this2.search.toLowerCase());
      }).forEach(function (sound) {
        list.push(sound.name);
      });
      return list;
    },
    elements: function elements() {
      if (this.tag) {
        return this.tagNames;
      } else {
        return this.soundNames;
      }
    }
  },
  methods: {
    play: function play(sound) {
      var url = this.playURL + sound;
      if (this.destination !== '') {
        url += '?destination=' + this.destination;
      }
      this.$http.get(url);
    },
    updateSounds: function updateSounds() {
      var _this3 = this;

      this.$http.get(this.soundsURL).then(function (response) {
        _this3.sounds = response.data;
      });
    }
  },
  watch: {
    soundToPlay: function soundToPlay() {
      // add event listener on ended event of player to reset soundToPlay value.
      // else the watch trigger is never redone on update of same button
      var self = this;
      this.$refs.player.addEventListener('ended', function () {
        self.$emit('update:soundToPlay', '');
      });

      this.soundPath = this.playLocallyURL + this.soundToPlay;
      this.$refs.player.play();
    }
  },
  created: function created() {
    this.player = document.getElementById('player');
    this.updateSounds();
  }
});

/***/ }),
/* 8 */,
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SoundUpload_vue__ = __webpack_require__(10);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ed97107_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_jade_node_modules_vue_loader_lib_selector_type_template_index_0_SoundUpload_vue__ = __webpack_require__(25);
function injectStyle (ssrContext) {
  __webpack_require__(23)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SoundUpload_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ed97107_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_jade_node_modules_vue_loader_lib_selector_type_template_index_0_SoundUpload_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_upload_component__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_upload_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_upload_component__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SoundUpload',
  components: {
    FileUpload: __WEBPACK_IMPORTED_MODULE_0_vue_upload_component___default.a
  },
  data: function data() {
    var basepath = '';
    if (false) {
      basepath = 'http://localhost:10101';
    };
    return {
      uploadPath: basepath + '/api/v1/sounds',
      filename: '',
      files: [],
      soundName: ''
    };
  },

  methods: {
    updateValue: function updateValue(value) {
      var refresh = true;
      if (this.files) {
        for (var i = 0; i < this.files.length; i++) {
          if (this.files[i].success === false) {
            refresh = false;
          }
        }
        if (refresh === true) {
          window.location.reload();
        }
      }
    }
  }
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_bootstrap_toggle__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_bootstrap_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_bootstrap_toggle__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'register',
  components: { BootstrapToggle: __WEBPACK_IMPORTED_MODULE_1_vue_bootstrap_toggle___default.a },
  data: function data() {
    var loc = window.location;
    var uri = '';
    if (loc.protocol === 'http:') {
      uri = 'ws:';
    } else {
      uri = 'wss:';
    }
    uri += '//' + loc.host;
    if (false) {
      uri = 'ws://localhost:10101';
    }
    uri += '/api/v1/clients/register';
    return {
      ws: {},
      name: '',
      share: false,
      registerURL: uri
    };
  },

  props: {
    soundToPlay: String
  },
  methods: {
    updateDest: function updateDest(destination) {
      this.$emit('update:destination', destination);
    },
    register: function register() {
      var vm = this;
      // toggle the connect state
      this.share = !this.share;
      if (!this.share) {
        this.ws.close(1000);
        return;
      }

      // connect the clients to the websocket
      this.ws = new WebSocket(vm.registerURL);
      this.ws.onopen = function (event) {
        vm.ws.send(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ name: vm.name }));
      };
      this.ws.onerror = function (event) {
        console.log('An error happened: ' + event);
      };
      this.ws.onmessage = function (event) {
        var msg = JSON.parse(event.data);
        if (msg.name && msg.name !== '') {
          vm.name = msg.name;
          return;
        }
        if (msg.type && msg.type === 'sound') {
          vm.$emit('register:play', msg.data);
        } else {
          console.log('Received unhandled message: ' + msg);
        }
      };
    },
    unregister: function unregister() {
      if (!this.share) {
        return;
      }
      this.ws.close(1000);
      this.share = !this.share;
    }
  },
  created: function created() {
    this.register();
  }
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_resource__ = __webpack_require__(35);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_resource__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(3);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ab03cf1a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_jade_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(32);
function injectStyle (ssrContext) {
  __webpack_require__(17)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ab03cf1a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_jade_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 17 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 18 */,
/* 19 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"destination"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){return _vm.updateClients()}}},[_vm._v("Refresh")]),_c('div',{staticClass:"list"},_vm._l((_vm.clients),function(c){return _c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.client),expression:"client"}],attrs:{"type":"radio","id":c},domProps:{"value":c,"checked":_vm._q(_vm.client,c)},on:{"change":function($event){_vm.client=c}}}),_c('label',{attrs:{"for":c}},[_vm._v(_vm._s(c))])])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 21 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"player"},[_c('audio',{ref:"player",attrs:{"src":_vm.soundPath,"autoplay":"autoplay"}}),_c('div',{staticClass:"options"},[_c('div',{staticClass:"searcher"},[_c('div',{staticClass:"toggler"},[_c('bootstrap-toggle',{attrs:{"options":{off:'<i class="fa fa-play"></i> Sounds', on:'<i class="fa fa-pause"></i> Tags'}},model:{value:(_vm.tag),callback:function ($$v) {_vm.tag=$$v},expression:"tag"}})],1)]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],attrs:{"type":"text","placeholder":"search sound"},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})]),_c('div',{staticClass:"list"},_vm._l((_vm.elements),function(elem){return _c('div',[_c('button',{staticClass:"btn btn-primary play-btn",on:{"click":function($event){return _vm.play(elem)}}},[_vm._v(_vm._s(elem))])])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 23 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 24 */,
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jumbotron soundUpload SoundUpload"},[_c('div',{staticClass:"upload-files"},[_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-md-2 col-form-label vert-spacer",attrs:{"for":"inputField"}},[_vm._v("Sound name")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.soundName),expression:"soundName"}],staticClass:"col-md-5 vert-spacer",attrs:{"type":"text","id":"inputField"},domProps:{"value":(_vm.soundName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.soundName=$event.target.value}}}),_c('file-upload',{ref:"upload",staticClass:"btn btn-primary col-md-4 spacer soundUploadBtn",attrs:{"post-action":_vm.uploadPath,"size":1048576,"data":{name:_vm.soundName},"name":"uploadFile"},on:{"input":_vm.updateValue},model:{value:(_vm.files),callback:function ($$v) {_vm.files=$$v},expression:"files"}},[_c('i',{staticClass:"fa fa-file"}),_c('span',[_vm._v(" Choose sound")])])],1),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.soundName!=''),expression:"soundName!=''"}],staticClass:"row"},[_c('div',{staticClass:"col-md-4"}),(!_vm.$refs.upload || !_vm.$refs.upload.active && _vm.soundName!='')?_c('button',{staticClass:"btn btn-success col-md-4 soundUploadBtn",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.$refs.upload.active = true}}},[_c('i',{staticClass:"fa fa-upload"}),_c('span',[_vm._v(" Start uploading")])]):_c('button',{staticClass:"btn btn-danger col-md-4 soundUploadBtn",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.$refs.upload.active = false}}},[_c('i',{staticClass:"fa fa-times"}),_c('span',[_vm._v(" Stop upload")])])]),_c('div',{staticClass:"row vert-spacer"},[_c('div',{staticClass:"col-md-4"}),_vm._l((_vm.files),function(f,index){return _c('div',{key:f.id,staticClass:"col-md-4"},[(f.error)?_c('span',[_vm._v(_vm._s(f.error))]):(f.success)?_c('span',{staticClass:"alert alert-success"},[_vm._v("Successfully uploaded sound")]):_vm._e()])})],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Register_vue__ = __webpack_require__(11);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0131f514_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_jade_node_modules_vue_loader_lib_selector_type_template_index_0_Register_vue__ = __webpack_require__(31);
function injectStyle (ssrContext) {
  __webpack_require__(27)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Register_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0131f514_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_jade_node_modules_vue_loader_lib_selector_type_template_index_0_Register_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 27 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"register"},[_c('div',{staticClass:"list"},[_c('button',{staticClass:"btn btn-primary",class:{ on: !_vm.share, off: _vm.share },on:{"click":function($event){return _vm.register()}}},[_vm._v(_vm._s(_vm.share ? "Disconnect" : "Connect"))]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"}],attrs:{"type":"text","placeHolder":"Your name","value":""},domProps:{"value":(_vm.name)},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.register()},"click":function($event){return _vm.unregister()},"focus":function($event){return $event.target.select()},"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('nav',{staticClass:"navbar navbar-expand-lg"},[_c('a',{staticClass:"navbar-brand",attrs:{"href":"#"},on:{"click":function($event){_vm.currentTab = ''}}},[_vm._v("Bell")]),_c('div',{staticClass:"collapse navbar-collapse",attrs:{"id":"navbarSupportedContent"}},[_c('ul',{staticClass:"navbar-nav mr-auto"},_vm._l((_vm.tabs),function(tab){return _c('li',{key:tab,staticClass:"nav-item",on:{"click":function($event){_vm.currentTab = tab}}},[_c('a',{attrs:{"href":"#"}},[_vm._v(_vm._s(tab))])])}),0)]),_vm._m(0)]),_c('Destination',{class:{hidden: _vm.selectedComponent(_vm.currentTab, 'Destination')},attrs:{"destination":_vm.dest,"reloadDest":_vm.reloadDest},on:{"update:destination":function($event){_vm.dest = $event}}}),_c('Register',{class:{hidden: _vm.selectedComponent(_vm.currentTab, 'Register')},attrs:{"soundToPlay":_vm.soundToPlay},on:{"register:play":function($event){_vm.soundToPlay = $event}}}),_c('SoundUpload',{class:{hidden: _vm.selectedComponent(_vm.currentTab, 'SoundUpload')}}),_c('List',{attrs:{"soundToPlay":_vm.soundToPlay,"destination":_vm.dest},on:{"update:soundToPlay":function($event){_vm.soundToPlay = $event}}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"navbar-toggler custom-toggler",attrs:{"type":"button","data-toggle":"collapse","data-target":"#navbarSupportedContent","aria-controls":"navbarSupportedContent","aria-expanded":"true","aria-label":"Toggle navigation"}},[_c('span',{staticClass:"custom-toggler"},[_c('i',{staticClass:"fa fa-bars white"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_List__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_SoundUpload__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Destination__ = __webpack_require__(4);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'List',
    component: __WEBPACK_IMPORTED_MODULE_2__components_List__["a" /* default */]
  }, {
    path: '/upload',
    name: 'SoundUpload',
    component: __WEBPACK_IMPORTED_MODULE_3__components_SoundUpload__["a" /* default */]
  }, {
    path: '/destination',
    name: 'destination',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Destination__["a" /* default */]
  }]
}));

/***/ }),
/* 34 */,
/* 35 */,
/* 36 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[12]);


// WEBPACK FOOTER //
// static/js/app.28796e2bbdc5734ce02c.js